<div class="row" *ngIf="!hasLoadedAssessment">
  <div class="col-xs-12">
    <p class="alert alert-warning"><app-spin-icon></app-spin-icon> Loading Assessment data...</p>
  </div>
</div>
<div class="row" *ngIf="hasLoadedAssessment">
  <div class="col-1">
    <app-back-button></app-back-button>
  </div>
  <div class="col">
    <h2 class="h2-responsive text-center">{{assessment.name}}</h2>
  </div>
</div>
<div class="row">
  <mdb-tabset #staticTabs [buttonClass]="'col nav-tabs tabs-3 primary-color'" [contentClass]="'card'" class="col-12">
    <mdb-tab heading="General">

    <form>
        <div role="alert">
          <div *ngIf="messages.saveSuccess">Assessment Saved!</div>
          <div *ngIf="messages.saveFailed">Error occurred in saving your assessment. Please try again.</div>
        </div>
        <div class="form-group">
          <label for="name">Unique Identifier:</label>
          <input class="form-control" type="text" id="uid" name="uid" [(ngModel)]="assessment.uid" />
        </div>
        <div class="form-group">
          <label for="name">Name:</label>
          <input class="form-control" type="text" id="name" name="name" [(ngModel)]="assessment.name" />
        </div>
        <div class="form-group">
            <label for="instructions">Instructions:</label>
            <textarea class="form-control" id="instructions" name="instructions" [(ngModel)]="assessment.instructions"></textarea>
        </div> 
        <div class="form-group">
            <label for="description">Description:</label>
            <textarea class="form-control" id="description" name="description" [(ngModel)]="assessment.description"></textarea>
        </div>
        <div class="form-group">
          <label for="therapistDescription">Therapist Description:</label>
          <textarea class="form-control" id="therapistDescription" name="therapistDescription" [(ngModel)]="assessment.therapistDescription"></textarea>
      </div>
        
        <div class="form-group">
            <label for="creator">Creator:</label>
            <input class="form-control" type="text" id="creator" name="creator" [(ngModel)]="assessment.creator" />
        </div>
        <div class="form-group">
            <label for="creator">Creator Url:</label>
            <input class="form-control" type="text" id="creatorUrl" name="creatorUrl" [(ngModel)]="assessment.creatorUrl" />
        </div>
        <div class="form-group">
          <label for="resourcesURL">Resources URL:</label>
          <input class="form-control" type="text" id="resourcesURL" name="resourcesURL" [(ngModel)]="assessment.resourcesURL" />
        </div>
        <input class="btn btn-primary" type="submit" (click)="save()" value="Save" />
      </form>
    </mdb-tab>
    <mdb-tab heading="Scales">
        <a [routerLink]="['scale','new']"  type="button" class="btn btn-primary">New Scale</a>
        <!--TODO: stephen move this to <scales-list></scales-list>-->
        <p class="alert alert-info" *ngIf="assessment.scales.length <= 0">No scales exist</p>
        <table class="table" *ngIf="assessment.scales.length">
          <thead class="primary-color text-white">
            <tr>
              <th>Title</th>
              <th>Score Multiplier</th>
              <th>Ranges</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tr *ngFor="let scale of assessment.scales; let first = first; let last = last;">
            
            <td class="w-25">
                {{scale.name}}
            </td>
            <td>
              {{scale.multiplier}}
            </td>
            <td class="w-50">
              <span *ngFor="let range of scale.ranges;">{{range.displayName}}&nbsp;</span>
            </td>
            <td class="w-25">
                <button (click)="moveUpScale(scale)" [disabled]="first" type="button" class="btn btn-primary btn-sm" aria-label="Up">
                    <span class="fa fa-arrow-up" aria-hidden="true"></span>
                  </button>
                  <button (click)="moveDownScale(scale)" [disabled]="last" type="button" class="btn btn-primary btn-sm" aria-label="Down">
                    <span class="fa fa-arrow-down" aria-hidden="true"></span>
                  </button>
              <button [routerLink]="['scale',scale.id,'edit']" 
                type="button" class="btn btn-primary btn-sm" aria-label="Edit">
                <span class="fa fa-edit" aria-hidden="true"></span>
              </button>
              <button (click)="deleteScale(scale)" type="button" class="btn btn-secondary btn-sm" aria-label="Delete">
                <span class="fa fa-trash" aria-hidden="true"></span>
              </button>
            </td>
          </tr>
        </table>
    </mdb-tab>
    <mdb-tab heading="Question Sets">
      <a [routerLink]="['question-set', 'new']"  type="button" class="btn btn-primary">New Question Set</a>
      <p class="alert alert-info" *ngIf="assessment.question_sets.length <= 0">No Question Sets exist</p>
      <!--<question-set-list></question-set-list>-->
      <table class="table" *ngIf="assessment.question_sets.length">
        <thead class="primary-color text-white">
          <tr>
            <th>Title</th>
            <th># of Questions</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tr *ngFor="let questionSet of assessment.question_sets; let first = first; let last = last;">
          <td>
              {{questionSet.title}}
          </td>
          <td>
            {{questionSet.questions.length}}
          </td>
          <td>
            <button (click)="moveUpSet(questionSet)" [disabled]="first" type="button" class="btn btn-primary btn-sm" aria-label="Up">
              <span class="fa fa-arrow-up" aria-hidden="true"></span>
            </button>
            <button (click)="moveDownSet(questionSet)" [disabled]="last" type="button" class="btn btn-primary btn-sm" aria-label="Down">
              <span class="fa fa-arrow-down" aria-hidden="true"></span>
            </button>
            <button [routerLink]="['question-set',questionSet.id,'edit']" type="button" class="btn btn-primary btn-sm" aria-label="Edit">
              <span class="fa fa-edit" aria-hidden="true"></span>
            </button>
              <button (click)="deleteQuestionSet(questionSet)" type="button" class="btn btn-primary btn-sm" aria-label="Delete">
              <span class="fa fa-trash" aria-hidden="true"></span>
            </button>
          </td>
        </tr>
      </table>
    </mdb-tab>
    <mdb-tab heading="Raw Edit">
        <textarea class="text-editor-window" #reportContents [value]="getRawAssessment()"></textarea>
        <input type="button" class="btn btn-primary" (click)="updateAssessmentContents()" value="Update" />
    </mdb-tab>
  </mdb-tabset>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/assessment-edit/assessment-edit.component.html